import { z } from 'zod'

// Профиль компании — только имя: slug принадлежит хабу и в PATCH не уходит,
// поэтому в схеме правки его нет (иначе компания с не подходящим под SLUG_RE
// адресом вообще не сохранялась бы). Реквизиты и контакты — независимые секции
// со своими диалогами (requisites-dialog / contact-dialog).
export const EditCompanySchema = z.object({
  name: z.string().min(1, 'Укажите название'),
})
export type EditCompanyInput = z.infer<typeof EditCompanySchema>

// Форматы реквизитов повторяют валидацию бэка (company/entity.go NewRequisites):
// иначе ошибка приезжает тостом без указания, какое поле не так.
const REQUISITE_RULES: Record<string, { valid: (v: string) => boolean; hint: string }> = {
  inn: { valid: (v) => /^(\d{10}|\d{12})$/.test(v), hint: 'ИНН — 10 или 12 цифр' },
  kpp: { valid: (v) => [...v].length === 9, hint: 'КПП — 9 символов' },
  ogrn: { valid: (v) => /^(\d{13}|\d{15})$/.test(v), hint: 'ОГРН — 13 или 15 цифр' },
}

// Подсказка об ошибке реквизита; пустое значение допустимо (очистка поля).
export function requisiteError(key: string, value: string): string | undefined {
  const rule = REQUISITE_RULES[key]
  if (!rule || value === '' || rule.valid(value)) return undefined
  return rule.hint
}
